import { render } from "./reservation.vue?vue&type=template&id=b9b5ffb2&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"

import "./reservation.vue?vue&type=style&index=0&id=b9b5ffb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b5ffb2"]])

export default __exports__